"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBasketStore = void 0;
const pinia_1 = require("pinia");
const Basket_1 = __importDefault(require("../src/api/Basket"));
const get_1 = __importDefault(require("lodash/get"));
exports.useBasketStore = (0, pinia_1.defineStore)('basket', {
    state: () => {
        return {
            products: [],
            extras: [],
            total: 0,
        };
    },
    actions: {
        /**
         * Set Extra
         *
         * Adds, removes or updates listing extras. These items are stored temporarily
         * in the extras array, once the user is ready to add the main listing to
         * their basket, the extras will also be pushed with the API request.
         * @param product
         * @param type
         * @param quantity
         * @param listingSlug Used to verify extras
         */
        setExtra(product, type, quantity, listingSlug) {
            const index = this.extras.findIndex((e) => e.product === product);
            // If item hasn't been found add to array
            if (index === -1) {
                this.extras.push({ product: product, type: type, quantity: quantity, listingSlug: listingSlug });
            }
            else {
                if (quantity === 0) {
                    // If new quantity is 0, remove from array
                    this.extras.splice(index, 1);
                }
                else {
                    // Update extra quantity with new quantity
                    this.extras[index].quantity = quantity;
                }
            }
        },
        removeExtras(productSlug) {
            this.extras.forEach(extra => {
                // Once basket is working fix here.
            });
        },
        /**
         * Add Extras
         *
         * Loops through the extras array and pushes each item to the basket API.
         */
        addExtras() {
            return __awaiter(this, void 0, void 0, function* () {
                this.extras.forEach(extra => {
                    return Basket_1.default.add(extra.product, extra.type, extra.quantity).then(this.handleBasketResponse);
                });
            });
        },
        fetchBasket() {
            return __awaiter(this, void 0, void 0, function* () {
                return Basket_1.default.fetchBasket().then(this.handleBasketResponse);
            });
        },
        add(product, type, quantity) {
            return __awaiter(this, void 0, void 0, function* () {
                return Basket_1.default.add(product, type, quantity).then(this.handleBasketResponse);
            });
        },
        remove(product, type, quantity = null) {
            return __awaiter(this, void 0, void 0, function* () {
                this.removeExtras(product);
                return Basket_1.default.remove(product, type, quantity).then(this.handleBasketResponse);
            });
        },
        update(product, type, quantity = null) {
            return __awaiter(this, void 0, void 0, function* () {
                return Basket_1.default.update(product, type, quantity).then(this.handleBasketResponse);
            });
        },
        handleBasketResponse(response) {
            this.products = (0, get_1.default)(response, 'data.products', []);
            this.total = (0, get_1.default)(response, 'data.total', 0);
            return response;
        },
    },
});
